<div class="odx-bar-parent h-100" odxLayout="flex">
  <app-configuration-wizard-back-button #backButton [project]="project" [floorplanGroup]="FloorplanMenuType.MONITORING_TELEMETRY">
  </app-configuration-wizard-back-button>
  <odx-wizard #configurationWizard [vertical]="true" (activeStepChanged)="activeStep = $event">
    <odx-wizard-step i18n="@@telemetryConfiguration.wizard.step1">Family</odx-wizard-step>
    @if (hasFamilyVariantStep) {
      <odx-wizard-step i18n="@@telemetryConfiguration.wizard.variant">Variant</odx-wizard-step>
    }
    @if (hasSensorStep) {
      <odx-wizard-step i18n="@@telemetryConfiguration.wizard.step2">Sensor</odx-wizard-step>
    }
    @if (hasAdditionalBatteriesStep) {
      <odx-wizard-step i18n="@@telemetryConfiguration.wizard.step3">Additional Batteries</odx-wizard-step>
    }
    <odx-wizard-step i18n="@@telemetryConfiguration.wizard.step4">Summary</odx-wizard-step>
  </odx-wizard>

  <app-product-family-selector
    class="w-100"
    [hidden]="activeStep !== 0"
    [title]="TelemetrySelectorTitleKeyMap[TelemetrySelectorType.FAMILY]"
    [originalFamily]="originalConfiguration ?? MonitoringCategory.TELEMETRY"
    [category]="MonitoringCategory.TELEMETRY"
    [categoryLabel]="overviewCategoryLabelMap[TelemetrySelectorType.FAMILY]"
    (familySelect$)="setSelectedFamily($event)"
    (formReady)="selectedFamilyForm = $event"
  ></app-product-family-selector>

  @if (family; as currentFamily) {
    @if (hasFamilyVariantStep) {
      <app-option-selector
        class="w-100"
        [hidden]="activeStep !== familyVariantStepIndex"
        [selectedFamily]="currentFamily"
        [originalOptions]="originalFamilyVariantOptions"
        [title]="TelemetrySelectorTitleKeyMap[TelemetrySelectorType.FAMILY]"
        [step]="familyVariantStep"
        [hasQuantities]="true"
        [category]="MonitoringCategory.TELEMETRY"
        [categoryLabel]="overviewCategoryLabelMap[TelemetrySelectorType.FAMILY]"
        (optionsSelect$)="setSelectedFamilyVariant($event)"
        (formReady)="selectedFamilyVariantForm = $event"
      ></app-option-selector>
    }

    @if (hasSensorStep) {
      <app-option-selector
        class="w-100"
        [hidden]="activeStep !== sensorStepIndex"
        [selectedFamily]="currentFamily"
        [originalOptions]="originalSensorOptions"
        [title]="TelemetrySelectorTitleKeyMap[TelemetrySelectorType.SENSOR]"
        [step]="sensorStep"
        [hasQuantities]="true"
        [category]="MonitoringCategory.TELEMETRY"
        [categoryLabel]="overviewCategoryLabelMap[TelemetrySelectorType.SENSOR]"
        (optionsSelect$)="setSelectedSensor($event)"
        (formReady)="selectedSensorForm = $event"
      >
      </app-option-selector>
    }

    @if (hasAdditionalBatteriesStep) {
      <app-option-selector
        class="w-100"
        [hidden]="activeStep !== additionalBatteriesStepIndex"
        [selectedFamily]="currentFamily"
        [originalOptions]="originalAdditionalBatteries"
        [title]="TelemetrySelectorTitleKeyMap[TelemetrySelectorType.ADDITIONAL_BATTERIES]"
        [step]="additionalBatteriesStep"
        [category]="MonitoringCategory.TELEMETRY"
        [categoryLabel]="overviewCategoryLabelMap[TelemetrySelectorType.ADDITIONAL_BATTERIES]"
        [hasQuantities]="true"
        (optionsSelect$)="setSelectedAdditionalBatteries($event)"
        (formReady)="selectedAdditionalBatteriesForm = $event"
      >
      </app-option-selector>
    }
  }

  @if (activeStep === summaryStepIndex) {
    <app-monitoring-overview
      [hidden]="activeStep !== summaryStepIndex"
      [title]="TelemetrySelectorTitleKeyMap[TelemetrySelectorType.OVERVIEW]"
      [sections]="groupedSections"
      [showCategory]="true"
    ></app-monitoring-overview>
  }

  <app-product-config-stepper-bar
    (dismiss)="backButton.navigateBack()"
    (next)="onSubmit()"
    (previous)="onPrevious()"
    [activeStep]="activeStep"
    [steps]="steps"
  >
  </app-product-config-stepper-bar>
</div>
